import { LoadingButton } from '@mui/lab';
import { Avatar, Box, Button, Card, Grid, LinearProgress, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { firestore } from '../../../../../contexts/FirebaseContext';

function UsersCard({ add = true, dataUser = {}, hostUser }) {
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const { displayName, email, id, photoURL } = dataUser;
  const { enqueueSnackbar } = useSnackbar();

  const addAssignedUser = async () => {
    console.log('prob');
    setLoadingAdd(true);
    const assignedUsersArr = hostUser?.assignedUsers;
    try {
      if (assignedUsersArr) {
        const newArr = [...assignedUsersArr, id];
        await firestore.collection('users').doc(hostUser.id).update({ assignedUsers: newArr });

        await firestore.collection('users').doc(id).update({ hostUser: hostUser.id });

        enqueueSnackbar('Usuario asignado', { variant: 'success' });
        setLoadingAdd(false);
      } else {
        await firestore
          .collection('users')
          .doc(hostUser.id)
          .update({ assignedUsers: [id] });

        await firestore.collection('users').doc(id).update({ hostUser: hostUser.id });

        enqueueSnackbar('Usuario asignado', { variant: 'success' });
        setLoadingAdd(false);
      }
    } catch (error) {
      enqueueSnackbar('Se a producido un error', { variant: 'error' });
      setLoadingAdd(false);
    }
  };

  const removeAssignedUser = async () => {
    setLoadingRemove(true);
    const assignedUsersArr = hostUser?.assignedUsers;
    try {
      const newArr = assignedUsersArr.filter((item) => item !== id);

      await firestore.collection('users').doc(hostUser.id).update({ assignedUsers: newArr });

      await firestore.collection('users').doc(id).update({ hostUser: null });

      enqueueSnackbar('Usuario removido', { variant: 'success' });
      setLoadingRemove(false);
    } catch (error) {
      enqueueSnackbar('Se ha producido un error', { variant: 'error' });
      setLoadingRemove(false);
    }
  };
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Card
        sx={{ padding: '15px', display: 'flex', gap: '15px', alignItems: 'center', height: '100%', cursor: 'pointer' }}
        onClick={add ? addAssignedUser : removeAssignedUser}
      >
        <Avatar src={photoURL} />
        <Box>
          <Typography variant="subtitle2" fontSize="13px">
            {displayName}
          </Typography>
          <Typography fontSize="10px">{email}</Typography>
          {/* {add ? (
            <LoadingButton loading={loadingAdd} onClick={addAssignedUser} variant="contained" size="small">
              Asignar
            </LoadingButton>
          ) : (
            <LoadingButton loading={loadingRemove} onClick={removeAssignedUser} variant="contained" size="small">
              Quitar
            </LoadingButton>
          )} */}
        </Box>
      </Card>
      {loadingAdd && <LinearProgress />}
      {loadingRemove && <LinearProgress />}
    </Grid>
  );
}

export default UsersCard;
